export const SET_HRES33U_INDEX_DISP = 'SET_HRES33U_INDEX_DISP'
export const GET_HRES33U_INDEX_DISP = 'GET_HRES33U_INDEX_DISP'
export const SET_HRES33U_DETAIL_DISP = 'SET_HRES33U_DETAIL_DISP'
export const GET_HRES33U_DETAIL_DISP = 'GET_HRES33U_DETAIL_DISP'
export const SET_HRES33U_COLUMNS = 'SET_HRES33U_COLUMNS'
export const GET_HRES33U_COLUMNS = 'GET_HRES33U_COLUMNS'
export const SET_HRES33U_LABELS = 'SET_HRES33U_LABELS'
export const GET_HRES33U_LABELS = 'GET_HRES33U_LABELS'
export const RECEIVED_HRES33U_COLUMNS_LABELS = 'RECEIVED_HRES33U_COLUMNS_LABELS'
export const SET_HRES33U_INDEX = 'SET_HRES33U_INDEX'
export const GET_HRES33U_INDEX = 'GET_HRES33U_INDEX'
export const RECEIVED_HRES33U_INDEX = 'RECEIVED_HRES33U_INDEX'
export const SET_HRES33U_INDEX_SELECTED = 'SET_HRES33U_INDEX_SELECTED'
export const GET_HRES33U_INDEX_SELECTED = 'GET_HRES33U_INDEX_SELECTED'

export const SET_HRES33U_DETAIL = 'SET_HRES33U_DETAIL'
export const GET_HRES33U_DETAIL = 'GET_HRES33U_DETAIL'
export const RECEIVED_HRES33U_DETAIL = 'RECEIVED_HRES33U_DETAIL'

export const TOGGLE_HRES33U_PAGE = 'TOGGLE_HRES33U_PAGE'
export const POST_HRES33U_SEND_APPROVE = 'POST_HRES33U_SEND_APPROVE'



// WEBPACK FOOTER //
// ./src/store/modules/hres33u/mutation-types.js